import { Button } from 'components/ui/button';
import { PAYMENT_CONFIG } from 'state/paymentConfig/type';

interface NoDevicesMessageProps {
  defaultProvider: PAYMENT_CONFIG.IProcessors | undefined;
  onAddDevice: () => void;
}

const NoDevicesMessage = ({ defaultProvider, onAddDevice }: NoDevicesMessageProps) => {
  return (
    <div className="flex items-center justify-center max-w-3xl">
      No hardware locations to show.
      <Button
        variant="link"
        className="ml-1 p-0 h-auto"
        disabled={!defaultProvider}
        onClick={onAddDevice}
      >
        Add a new payment device
      </Button>
    </div>
  );
};

export default NoDevicesMessage;
